import { getUTCDateMS } from './timeFrameDropdownUtils';

/**
 * Returns the UTC timestamp in milliseconds from a specified number of days back.
 *
 * @param {number} daysBack - the number of days to go back in time
 * @return {{ startTimestampUtcMS: string; endTimestampUtcMs: string }} the start and end UTC timestamps in milliseconds
 */
const getUtcTimestampMsFromDaysBack = (
  daysBack: number,
): { startTimestampUtcMS: string; endTimestampUtcMs: string } => {
  const startDate = new Date(Date.now() - daysBack * 24 * 60 * 60 * 1000); // Subtracts daysBack from current date in MS
  const startTimestampUtcMS = getUTCDateMS(startDate).toString();
  const endTimestampUtcMs = getUTCDateMS(new Date()).toString();

  return {
    startTimestampUtcMS,
    endTimestampUtcMs,
  };
};

export default getUtcTimestampMsFromDaysBack;
